import { query_request_order_list } from '@/api/jms-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '报单单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写报单单号',
    },
    {
      type: 'remotemodal',
      name: 'franchisee_id',
      label: '加盟商',
      disabled: false,
      placeholder: '请选择加盟商',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-franchisee',
    },
    {
      type: 'remotemodal',
      name: 'product_id',
      label: '产品',
      disabled: false,
      placeholder: '请选择产品',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-product',
    },
    {
      type: 'rangepicker',
      name: 'date',
      label: '报单时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写报单时间',
    },
    {
      type: 'rangepicker',
      name: 'do_time',
      label: '审批时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写审批时间',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    code: null,
    franchisee_id: null,
    product_id: null,
    date: null,
    status: null,
    do_time: null,
  }),
};
const search_options = {
  status: [
    { value: None, name: '全部' },
    { value: 0, name: '已提交' },
    { value: 1, name: '已通过' },
    { value: 2, name: '已拒绝' },
    { value: 3, name: '已取消' },
    { value: 4, name: '已撤单' },
  ],
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '报单单号',
    width: 150,
    dataIndex: 'code',
    fixed: false,
    checked: true,
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'id',
    fixed: false,
    checked: false,
  },
  {
    title: '加盟商ID',
    width: 150,
    dataIndex: 'franchisee_id',
    fixed: false,
    checked: false,
  },
  {
    title: '名称',
    width: 150,
    dataIndex: 'franchisee__name',
    fixed: false,
    checked: true,
  },
  {
    title: '产品ID',
    width: 150,
    dataIndex: 'product_id',
    fixed: false,
    checked: false,
  },
  {
    title: '产品编码',
    width: 150,
    dataIndex: 'product__code',
    fixed: false,
    checked: true,
  },
  {
    title: '产品名称',
    width: 150,
    dataIndex: 'product__name',
    fixed: false,
    checked: true,
  },
  {
    title: '产品数量',
    width: 150,
    dataIndex: 'num',
    fixed: false,
    checked: true,
  },
  {
    title: '产品单价',
    width: 150,
    dataIndex: 'price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '产品金额',
    width: 150,
    dataIndex: 'total_price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '状态',
    width: 150,
    dataIndex: 'status',
    fixed: false,
    checked: true,
  },
  {
    title: '报单时间',
    width: 150,
    dataIndex: 'date',
    fixed: false,
    checked: true,
  },
  {
    title: '审批时间',
    width: 150,
    dataIndex: 'do_time',
    fixed: false,
    checked: true,
  },
  {
    title: '备注',
    width: 150,
    dataIndex: 'mark',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    fixed: false,
    checked: true,
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    fixed: false,
    checked: true,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_request_order_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
